import React, { createContext, useState } from 'react';
import Auth from './auth';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(Auth.getUser());
  const profileUrl = user?.profileImage?.url || null;

  return (
    <UserContext.Provider value={{ user, setUser, profileUrl }}>
      {children}
    </UserContext.Provider>
  );
};
